import {
  EditButton,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";
import { useAdmin } from "../../hooks/admin";

const PermissionShowActions = () => {
  const { hasPermission } = useAdmin();

  return (
    <TopToolbar>
      {hasPermission("permission.update") && <EditButton />}
    </TopToolbar>
  );
};

export const PermissionShow = () => {
  const { hasPermission } = useAdmin();

  if (!hasPermission("permission.view")) return null;

  return (
    <Show actions={<PermissionShowActions />}>
      <SimpleShowLayout>
        <TextField source="name" />
        <TextField source="description" />
      </SimpleShowLayout>
    </Show>
  );
};
